<template>
  <div
    v-if="showLoadingState < 2"
    key="loadingState"
  >
    <AtomLoadingPrimary/>
  </div>
</template>

<script>

export default {
  name: 'MoleculeEditionUpdatingLicence',

  data () {
    return {
      showLoadingState: 0
    }
  },

  created () {
    this.readAcademias()
  },

  methods: {
    readAcademias () {
      this.$services.read('academia', 'readAcademias', {}, [], this.$auth.filter)
        .then(response => {
          let currentAcademy = this.$store.getters.getAcademyData
          currentAcademy.licencia = response.data.find(a => a.id === this.$store.getters.getAcademyData.id).licencia
          localStorage.setItem('current_academy', JSON.stringify(currentAcademy))
          this.$store.commit('setAcademyData', currentAcademy)
          this.readAcademiaRecursosUsados()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readAcademiaRecursosUsados () {
      this.$services.read('academia', 'readAcademiaRecursosUsados', {}, [this.$store.getters.getAcademyData.id])
        .then(response => {
          localStorage.setItem('current_resources', JSON.stringify(response.data))
          this.$store.commit('setAcademyResources', response.data)
          this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myPayments.subject')}/${this.$t('mEditionMenu.billing.myPayments.children.subscribedPlan.subedition')}`)
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    }
  }
}
</script>
